import React from "react";

interface LogoProps {
  size?: "small" | "large";
  variant?: "contained" | "outlined" | "text";
}

const Logo: React.FC<LogoProps> = ({ size = "large", variant = "text" }) => {
  const logoText = size === "large" ? "Invyntra" : "In";
  const logoVariantClass =
    variant === "contained"
      ? "bg-primary-600 text-white px-4 py-2 rounded"
      : variant === "outlined"
      ? "border border-primary-600 text-primary-600 px-4 py-2 rounded"
      : "text-primary-600";
  return (
    <div className={`${logoVariantClass} text-xl font-semibold w-fit`}>
      {logoText}
    </div>
  );
};

export default Logo;
